import { render, staticRenderFns } from "./AscPlotDataTabWrapper.vue?vue&type=template&id=7145ca27&"
import script from "./AscPlotDataTabWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPlotDataTabWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscPlotDataTabWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports